export default __webpack_public_path__ + "static/media/uploader-abbottXtra-4.5aca2b44.png";